<template>
 <div class="ui centered grid">
    <div class="three wide column"></div>
    <div class="ten wide column">
        <div class="row">
            <div class="ui center aligned container">
                <h1 class="ui header">Inventaria Rudolphina</h1>
                <h5 class="ui header">Art for Display: The Painting Collection of Emperor Rudolf II within the Context of Collecting Practices circa 1600</h5>
            </div>
        </div>
        <div class="row" style="padding-top: 40px;">
            <TheCarousel v-bind:slides="slides" type='home' v-bind:fluid="true" v-bind:auto="true" v-bind:fx="true"></TheCarousel>
        </div>
        <div class="row" style="margin: 10px 0px 20px 0px;">
            <div class="ui message">
                The painting collection of Emperor Rudolf II in Prague, scattered during the Thirty Years’ War, was one of the foremost ensembles of its kind in Europe. The inventories, period testimonies and other sources, and last but not least identified works, provide an idea of its scope. Heuristic research and the "Art for display" database allow an analysis of the collection with a regard to pictorial genres composition and the representation of painters, painting “schools”, also its spatial arrangement and administration.
            </div>
        </div>
        <div class="row">
            <div class="ui centered grid">
                <div class="eight wide column">
                    <div class="ui segment" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1595_Brussels', page:1 }})">
                        <h3 class="ui header">1595 Brussels Inventory</h3>
                        <p style="">The 1595 inventory is part of the archduke Ernst (brother of Rudolf II) collection list from Coudenberg Palace in Brussels, drawn up after Ernest’s death in 1595. Later in 1595, all of Ernest’s artworks were transported to Vienna and dispersed between imperial collections in Prague and Vienna. See: Marcel de Maeyer, Albert en Isabella en de Schilderkunst, Brussels 1955, pp. 259-261.</p>
                    </div>
                    <div class="ui segment">
                        <router-link to="/item/BrA-3">
                            <img src="/static/home/Gundelach_Amor_and_Psyche.jpg" class="ui fluid image">
                        </router-link>
                      </div>
                       <div class="ui segment" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1610_19_Vienna', page:1 }})">
                        <h3 class="ui header">1610/19 Vienna Inventory A</h3>
                        <p>The inventory covers paintings transported after the death of Rudolf II by the emperor Matthias to Vienna, to the provisory settings in "Neuburg". See Reg. 19446 G published by Wilhelm Köhler, Aktenstücke zur Geschichte der Wiener Kunstkammer in der herzoglichen Bibliothek zu Wolfenbüttel, in Jahrbuch der Kunsthistorischen Sammlungen des Allerhöchsten Kaiserhauses 26 (1906/1907), pp. VI-VIII.</p>
                    </div>
                     <div class="ui segment">
                        <h3 class="ui header">1621 Prague A</h3>
                        <p>The Inventory 1621 Prague A is a transcription of paintings listed on fols. 31v-48v in Ms. 8196 from Österreichische Nationalbibliothek (hinherto unpublished transcription made by Štěpán Vácha and Radka Heisslerová). The 1621 Inventory is the first inventory documenting artworks mostly acquired by Rudolf II at their original location at the Prague castle. According to Jürgen Zimmer the Ms. 8196 was made before 1621.</p>
                    </div>
                     <div class="ui segment">
                        <h3 class="ui header">1623 Briers A Inventory</h3>
                        <p>The Inventory 1623 Briers A covers 56 paintings that were offered to buy by Ferdinand II (due to their explicit erotic content) in Prague on the 30th of March 1623 to Daniel de Briers, merchant and jeweller from Frankfurt. However, not all of them were really sold. The digital edition is based on regest nr. 19422 BB published by Heinrich Zimmermann in Jahrbuch der Kunsthistorischen Sammlungen des Allerhöchsten Kaiserhauses 25 (1905), p. LI.</p>
                    </div>
                    <div class="ui segment">
                        <h3 class="ui header">1635 Prague Inventory</h3>
                        <p>The Prague 1635 Inventory covers the items 1–123 that consists of additions to the "Prague 1621" Inventory (items found during a revison of the imperial collection 16.-26. 4. 1635). See Reg. 19437 Heinrich Zimmermann, "Das Inventar der Prager Schatz- und Kunstkammer vom 6. Dezember 1621: nach Akten des k. und k. Reichsfinanzarchivs in Wien", in Jahrbuch der Kunsthistorischen Sammlungen des Allerhöchsten Kaiserhauses 25 (1905), p. LVIII–LX.</p>
                    </div>
                    <div class="ui segment">
                            <h3 class="ui header">1648 Prague</h3>
                            <p>The database covers Nr. 1-764 from the inventory "A" found by Beda Dudík in Skokloster Castle (now Stockholm, Riksarkivet, Skoklostersamlingen 2, E 8578, fasc. 720795, pag. 19-62.). It records items located in the Prague Castle before summer 1648 when they were mostly transported to Sweden. For edition see: Beda Dudík, Die Rudolphinische Kunst- und Raritätenkammer in Prag, in Mittheilungen der k. k. Central-Commission zur Erforschung und Erhaltung der Baudenkmale 12 (1867), p. XXXV-XLI.</p>
                       <!--     <p style="">The database covers Nr. 1-764 from the inventory "A" found by Beda Dudík in Skokloster Castle (Stockholm, Riksarkivet, Skoklosetersaml., E 8578). It records items located in the Prague castle before summer 1648 when they were mostly transported to Sweden. For edition see: Beda Dudík, Die Rudolphinische Kunst- und Raritätenkammer in Prag, in Mittheilungen der k. k. Central-Commission zur Erforschung und Erhaltung der Baudenkmale 12 (1867), p. XXXV-XLI.</p> -->
                    </div>
                     <div class="ui segment">
                            <h3 class="ui header">1652 Stockholm</h3>
                            <p>The database covers ca. 500 paintings from the inventory of the collection of Queen Christina in Stockholm in 1652, marked by Raphaël Trichet du Fresne as "from Prague" (Inventaire des raretez qui sont dans le cabinet des antiquitez de la Serenessime Reine de Suéde fait l'an 1652. - 1 Vol. Fol. 128 s., S 4, Kungliga biblioteket, Stockholm). The transcription is based on the edition by Olof Granberg, Galerie de tableaux de la reine Christine de Suède, Stockholm 1897, pp. XXV-L.
<a href="https://gallica.bnf.fr/ark:/12148/bpt6k6467712m/f99.item">link</a></p>
                       <!--     <p style="">The database covers Nr. 1-764 from the inventory "A" found by Beda Dudík in Skokloster Castle (Stockholm, Riksarkivet, Skoklosetersaml., E 8578). It records items located in the Prague castle before summer 1648 when they were mostly transported to Sweden. For edition see: Beda Dudík, Die Rudolphinische Kunst- und Raritätenkammer in Prag, in Mittheilungen der k. k. Central-Commission zur Erforschung und Erhaltung der Baudenkmale 12 (1867), p. XXXV-XLI.</p> -->
                    </div>
                    <div class="ui segment">
                        <h3 class="ui header">2020 Prague "Inventory"</h3>
                        <p>There are still a lot of paintings that is not possible to identify in the inventories. Nevertheless they were very probably made for the imperial collection of Rudolf II. You can find them in the 2020 Inventory.</p>
                    </div>
                </div>
                <div class="eight wide column">
                    <div class="ui segment" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1615_Brussels', page:1 }})">
                        <h3 class="ui header">1615 Brussels Inventory</h3>
                        <p style="">The Inventory lists 115 paintings bought by Albert VII, Archduke of Austria from the original collection of Rudolf II and transported from Prague to his residence in Brussels. Original now in Archives générales du Royaume, Secrétarerie d'Etat, Allemande, n. 426. See: Marcel de Maeyer, Albrecht en Isabella en de Schilderkunst, Brussels 1955, pp. 316-319.</p>
                    </div>
                    <div class="ui segment">
                    <router-link to="/item/VieA-25">
                        <div style="width:100%;overflow: hidden;">
                            <img src="/static/home/Correggio_Jupiter_and_Io.jpg" class="ui fluid image">
                        </div>
                      </router-link>  
                    </div>
                    <div class="ui segment">
                            <h3 class="ui header">1619 Vienna B Inventory</h3>
                            <p style="">The inventory covers paintings from the collection of emperor Matthias, formerly very probably in the collection of Rudolf II in Prague, listed in Viennese collection after 28th of June 1619. See Reg. 19448 H published by Wilhelm Köhler, Aktenstücke zur Geschichte der Wiener Kunstkammer in der herzoglichen Bibliothek zu Wolfenbüttel, in Jahrbuch der Kunsthistorischen Sammlungen des Allerhöchsten Kaiserhauses 26 (1906/1907), pp. IX-XIII.</p>
                        </div>
                        <div class="ui segment">
                            <h3 class="ui header">1621 Prague B</h3>
                            <p style="">The Inventory "Prague 1621" is an excerpt from Regest nr. 19421 from "Das Inventar der Prager Schatz- und Kunstkammer vom 6. Dezember 1621: nach Akten des k. und k. Reichsfinanzarchivs in Wien", published by Heinrich Zimmermann in Jahrbuch der Kunsthistorischen Sammlungen des Allerhöchsten Kaiserhauses 25 (1905). It covers numbers 811–1388 (pp. XXXVIII–XLIX). The original seems to be lost. According to Jürgen Zimmer it is a later version or copy of Ms. 8196 (1621 A Prague).</p>
                        </div> 
                        <div class="ui segment">
                            <h3 class="ui header">1623 Briers B</h3>
                            <p style="">The Inventory is a Transcription of paintings included in a broader "Memoriael" of items bought by Daniel de Briers and transported from Prague to Frankfurt am Main (Hessisches Hauptstaatsarchiv, Wiesbaden, Abt. 1165, Rechnungen. For the modern edition see: Gabriele Marcussen-Gwiazda, Der Bilderverkauf aus der Rudolfinischen Kunstkammer an den Frankfurter Juwelier Daniel de Briers, in: Die verschollene Leda. Joseph Heintz d. Ä., kaiserlicher Hofmaler und Augsburger Bürger, pp. 120-124.</p>
                        </div>
                        <div class="ui segment">
                     <img src="/static/home/inven_001.png" class="ui fluid image">
                    </div>
                </div>
                <div class="eight wide column">
                    
                </div>
                <div class="eight wide column">
                
                </div>
                <div class="eight wide column">
                   
                </div>
                <div class="eight wide column" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1619_Vienna', page:1 }})">
                    
                </div>
                <div class="eight wide column"  style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1621_Prague_A', page:1 }})">
                   
                </div>
                <div class="eight wide column" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1621_Prague_B', page:1 }})">
                     
                </div>
                <div class="eight wide column" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1623_Briers_A', page:1 }})">
                    
                </div>
                <div class="eight wide column"  style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1623_Briers_B', page:1 }})">
                    
                </div>
                <div class="eight wide column" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1635_Prague', page:1 }})">
                    
                </div>
                <div class="eight wide column" style="cursor:pointer" v-on:click="$router.push({ name: 'list', query: { inventory: '1635_Prague', page:1 }})">
                    
                </div>
               
               
            </div>
        </div>
    </div>
    <div class="three wide column"></div>
</div>

</template>

<script>
    import TheCarousel from '../components/TheCarousel.vue'
    export default {
        name: 'home',
        data() {
            return {
                inventorycount:{
                    prague1621:0,
                    briers1623:0,
                    prague1635:0
                },
                slides: [{
                        src: '/static/home/Rudolf-Aachen-crop.png',
                        title: 'Hans von Aachen, Portrait of Rudolf II, ca. 1606/1608, Kunsthistorisches Museum, Vienna',
                        itemid: false,
                        id: 0
                    },
                    {
                        src: '/static/home/list-crop.jpg',
                        title: 'Inventory of the Prague Castle collection (1621 Prague A), Ms. 8196, Österreichische Nationalbibliothek, Vienna',
                        itemid: false,
                        id: 1,
                        invert:true
                    },
                    {
                        src: '/static/home/PrgA-1365_PrgB-1365-homepage.jpg',
                        title: 'Leonardo da Vinci, Lady with an Ermine – Portrait of Cecilia Gallerani (ca. 1473–1536), ca. 1490, Princes Czartoryski Museum, Cracow',
                        itemid: 'PrgB-1365',
                        id: 2
                    },
                    {
                        src: '/static/home/Aachen_Pan_and_Selene-crop.png',
                        title: 'Hans von Aachen, Pan and Selene, 1600-1605, private collection',
                        itemid: 'PrgB-1228',
                        id: 3
                    },
                    {
                        src: '/static/home/Van-Veen-Amazonen-Skythen.png',
                        title: 'Otto van Veen, Amazons and Scythians, 1597/1599, Kunsthistorisches Museum, Vienna',
                        itemid: 'PrgB-1271a',
                        id: 4
                    },
                ]
            }
        },
        mount(){
            
        },
        components: {
            TheCarousel
        },
    }
</script>

<style scoped>
.voynich{ 
   font-family: 'Voynich123'; 
   font-weight: normal; 
   font-style: normal; 
}
    
</style>



// WEBPACK FOOTER //
// src/router/home.vue